import styled from 'styled-components';
import { Link } from 'ui/links';
import { DefaultActionType } from 'modules/graphql/types';
import { SETTINGS_DISPLAY_CONTENT } from './constants';

const StyledActionReadOnly = styled.div`
  display: flex;
  flex-direction: column;
`;

type DefaultActionProps = {
  action: DefaultActionType;
};

const { openUrl, openApp, openAppLabel, openUrlLabel, customActionLabel } =
  SETTINGS_DISPLAY_CONTENT.openAction;

export const DefaultActionReadOnly = ({ action }: DefaultActionProps) => {
  const { type, data } = action;

  const handleLabel = () => {
    switch (type) {
      case openUrl:
        return openUrlLabel;
      case openApp:
        return openAppLabel;
      default:
        return customActionLabel;
    }
  };

  const openActionValue = type === openApp || type === openUrl ? data : type;

  return (
    <StyledActionReadOnly>
      <div data-test="default-action-read-only-label">{handleLabel()}</div>

      {action && (
        <Link
          hasOpenNewTabIcon
          href={openActionValue}
          target="_blank"
          rel="noreferrer"
          data-test="default-action-read-only-link"
        >
          {openActionValue}
        </Link>
      )}
    </StyledActionReadOnly>
  );
};
